import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import * as FileSaver from 'file-saver';
import {ModuleService} from '../services/module.service';


@Component({
  selector: 'app-modal-read-mdi',
  templateUrl: './modal-read-mdi.component.html',
  styleUrls: ['./modal-read-mdi.component.css']
})
export class ModalReadMDIComponent implements OnInit {


  constructor(
    private router: Router,
    private translate: TranslateService,
    private moduleService: ModuleService,
    private modal: NgbActiveModal
  ) {
  }

  @Input() planMDI;
  @Input() idElaboration;

  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');


  facility = JSON.parse(this.localFacilities);
  id = JSON.parse(this.localID);
  modules = JSON.parse(this.localModules);
  currentFacility = this.facility[this.id];

  dateCreationPlan: string;
  module = 'MDI';
  titlePdf: string;

  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));
    this.splitDateCreation();
  }

  close() {
    this.modal.close();
  }


  // Method that splitted date creation of plan
  splitDateCreation() {
    const dateStr = this.planMDI.DataCreazione;
    const splittedDate = dateStr.split(' ', 3);
    this.dateCreationPlan = splittedDate[0];
  }

  downloadMDI() {
    this.moduleService.moduleDownload(this.currentFacility.myFacilities.ID, this.idElaboration, this.module)
      .subscribe(
        (data) => {

          this.translate.get('MDI_SHOW_MODAL.TITLE').subscribe((res: string) => {
            this.titlePdf = res + ' ' + this.dateCreationPlan;
          });

          const byteArray = new Uint8Array(atob(data.Base64FileContent).split('').map(char => char.charCodeAt(0)));
          const blob = new Blob([byteArray], {type: data.ContentType});
          FileSaver.saveAs(blob, this.titlePdf + '.pdf');

          this.close();
          return blob;
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }
}
